import styled from 'styled-components'

export const HeroImageStyled = styled.img`
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
`
